// Module
var code = "<div class=\"va-imis-utility-toast-item\"> <span class=\"va-imis-utility-toast-item-text\"></span> <span class=\"va-imis-utility-toast-item-close\">&times;</span> <button class=\"btn va-imis-utility-toast-item-btn\" type=\"button\">Yes</button> <button class=\"btn va-imis-utility-toast-item-btn\" type=\"button\">No</button> </div>";
// Exports
export default code;